// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });

    // check if page is scrolled from the top for header
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
        }
    });

    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });

    // Pages swiper
    var pagesswiper1 = new Swiper(".pages-swiper-1", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        pagination: {
            el: ".pages-pagination-1",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // Pages swiper
    var pagesswiper2 = new Swiper(".pages-swiper-2", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        pagination: {
            el: ".pages-pagination-2",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // Pages swiper
    var pagesswiper3 = new Swiper(".pages-swiper-3", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        pagination: {
            el: ".pages-pagination-3",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // Places swiper
    var placesswiper = new Swiper(".places-swiper", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        pagination: {
            el: ".places-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // News swiper
    var swiper = new Swiper(".news-swiper", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        spaceBetween: 200,
        pagination: {
            el: ".news-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // Article images
    var swiper = new Swiper(".article-images-swiper", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        spaceBetween: 200,
        pagination: {
            el: ".article-images-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    // parallax elements
    var image = document.getElementsByClassName("vertical-slow");
    new simpleParallax(image, {
        overflow: true,
        scale: 1.1,
    });

    var image = document.getElementsByClassName("vertical-middle");
    new simpleParallax(image, {
        overflow: true,
        scale: 1.4,
    });

    var image = document.getElementsByClassName("vertical-fast");
    new simpleParallax(image, {
        overflow: true,
        scale: 1.7,
    });

    var image = document.getElementsByClassName("horizontal-right");
    new simpleParallax(image, {
        overflow: true,
        scale: 3,
        orientation: "right",
    });

    var image = document.getElementsByClassName("horizontal-left");
    new simpleParallax(image, {
        overflow: true,
        scale: 3,
        orientation: "left",
    });

    var image = document.getElementsByClassName("parallax-inner");
    new simpleParallax(image, {
        scale: 1.4,
        orientation: "up",
    });

    // popup video toggle
    $(".menu-toggle").on("click", function () {
        $(this).toggleClass("active");
        $("#wrapper-navbar .right").toggleClass("active");
    });

    // building points section
    if ($(window).width() > 992) {
        var elems = $(".section-nine .point"),
            wrapper = $('<div class="points-wrapper" />');
        for (var i = 0; i < elems.length; i += 2) {
            elems
                .filter(":eq(" + i + "),:eq(" + (i + 1) + ")")
                .wrapAll(wrapper);
        }
    }

    // Experience logos
    var toplogoQuantity = $(".logos .top-bar .logo").length;
    var bottomlogoQuantity = $(".logos .bottom-bar .logo").length;
    var windowWidth = $(window).width();

    if ($(window).width() < 768) {
        var boxWidth = windowWidth / 3;
    } else {
        var boxWidth = windowWidth / 5;
    }

    var topmarqueeWidth = boxWidth * toplogoQuantity;
    var bottommarqueeWidth = boxWidth * bottomlogoQuantity;

    gsap.set(".logos .logo", {
        x: (i) => i * boxWidth,
    });

    gsap.to(".logos .top-bar .logo", {
        duration: 80,
        ease: "none",
        x: "+=" + topmarqueeWidth,
        modifiers: {
            x: gsap.utils.unitize((x) => parseFloat(x) % topmarqueeWidth),
        },
        repeat: -1,
    });

    gsap.to(".logos .bottom-bar .logo", {
        duration: 80,
        ease: "none",
        x: "-=" + bottommarqueeWidth,
        modifiers: {
            x: gsap.utils.unitize((x) => parseFloat(x) % bottommarqueeWidth),
        },
        repeat: -1,
    });

    // virtual swiper
    var mySwiper = new Swiper(".virtual-swiper", {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 2000,
        },
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
            rotate: 50,
            stretch: 80,
            depth: 200,
            modifier: 1,
            slideShadows: false,
        },
    });

    // popup video toggle
    $(".section-one .button").on("click", function () {
        $(".video-popup").addClass("active");
    });

    // popup video toggle
    $(".header-search svg").on("click", function () {
        $(".header-search form").addClass("active");
    });

    // popup video toggle
    $(".infos-sidebar .item").on("click", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
    });

    $(".video-popup").on("click", function () {
        $(".video-popup").removeClass("active");
        var $frame = $("iframe#video");
        var vidsrc = $frame.attr("src");
        $frame.attr("src", "");
        $frame.attr("src", vidsrc);
    });

    // downloads
    $(".download-button").on("click", function (e) {
        $(".download-popup-shadow").addClass("active");
        $(".download-popup").addClass("active");
        var currentfileLink = $(this).attr("downloadlink");
        var currentfileName = $(this).attr("filename");
        $("#saentysfdbm").attr("href", currentfileLink);
        $("#saentysfdbm").attr("download", currentfileName);
        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            $("body").addClass("subscribed");
            $("#saentysfdbm")[0].click();
        });
    });

    $(
        ".download-popup .close, .download-popup-shadow, .download-popup strong"
    ).on("click", function (e) {
        $(".download-popup-shadow").removeClass("active");
        $(".download-popup").removeClass("active");
    });

    $(".close-page").on("click", function (e) {
        window.history.back();
    });

    // page sub menu's
    $(".page-menu li:first-child").addClass("active");
    $(window).on("scroll", function () {
        $(".page-anchor").each(function () {
            if ($(window).scrollTop() >= $(this).offset().top - 0.5) {
                var currentItem = $(this).attr("id");
                $(".page-menu li").removeClass("active");
                $("." + currentItem).addClass("active");
            }
        });
    });

    // make fullscreen vimeo popup if button contains vimeo iframe link
    $('.button[href*="player.vimeo"').each(function () {
        $(this).addClass("hasvimeo");
        var Index = $(this).index();
        var videoLink = $(this).attr("href");
        var buttonTex = $(this).text();
        $(
            '<div class="vimeopopupvideo button-video-popup video-popup-' +
                Index +
                '"><div class="close"></div><iframe src="' +
                videoLink +
                '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>'
        ).insertAfter(".fold, .fold-inverted");
        $(this).replaceWith(
            '<span class="button button-' +
                Index +
                ' white-border arrow-right hasvimeo">' +
                buttonTex +
                "</span>"
        );
    });

    // open vimeo popup videos
    $(".hasvimeo").on("click", function () {
        var buttonid = $(this).index();
        $(".video-popup-" + buttonid + "").addClass("active");
    });

    // close vimeo popup videos
    $(".vimeopopupvideo").on("click", function () {
        $(this).removeClass("active");
        var iframe = $(this).children("iframe")[0].contentWindow;
        iframe.postMessage('{"method":"pause"}', "*");
    });

    // make fullscreen youtube popup if button contains youtube iframe link
    $('.button[href*="youtube.com/embed"').each(function () {
        $(this).addClass("hasyoutube");
        var Index = $(this).index();
        var videoLink = $(this).attr("href");
        var buttonTex = $(this).text();
        $(
            '<div class="youtubepopupvideo button-video-popup video-popup-' +
                Index +
                '"><div class="close"></div><iframe width="560" height="315" src="' +
                videoLink +
                '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>'
        ).insertAfter(".fold, .fold-inverted");
        $(this).replaceWith(
            '<span class="button button-' +
                Index +
                ' white white-border arrow-right hasyoutube">' +
                buttonTex +
                "</span>"
        );
    });

    // open youtube popup videos
    $(".hasyoutube").on("click", function () {
        var buttonid = $(this).index();
        $(".video-popup-" + buttonid + "").addClass("active");
    });

    // close youtube popup videos
    $(".youtubepopupvideo").on("click", function () {
        $(this).removeClass("active");

        var video = $(this).children("iframe").attr("src");
        $(this).children("iframe").attr("src", "");
        $(this).children("iframe").attr("src", video);
    });

    $(".articles-overview .filter-options .filter-option:first-child h4").text(
        "Catégorie"
    );

    // interview audio popup
    $(".interview .button").on("click", function () {
        $("audio").trigger("pause");
        $(".audio-wrapper").removeClass("active");
        $(this).parent().siblings(".audio-wrapper").addClass("active");
        $(this)
            .parent()
            .siblings(".audio-wrapper")
            .children("audio")
            .trigger("play");
    });

    $(".podcast .podcast-popup-toggle").on("click", function () {
        $(".audio-wrapper").removeClass("active");
        $(this).siblings(".audio-wrapper").addClass("active");
    });

    $(".iframe-toggle").on("click", function () {
        $(this).parent().parent().siblings(".audio-wrapper").addClass("active");
    });

    $(".audio-wrapper .close").click(function () {
        $(this).parent().removeClass("active");
        $(this)
            .siblings("iframe")
            .attr("src", $(this).siblings("iframe").attr("src"));
        $("audio").trigger("pause");
    });

    $("#news-section .pagination a").on("click", function () {
        var aTag = $("#news-section");
        $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
    });

    $("#filter .view-all").on("click", function (e) {
        $(this).addClass("active");
        $("#filter input").prop("checked", false);
        $("#filter").trigger("change");
    });

    $("#filter .view-all").addClass("active");

    $("#filter label").on("click", function (e) {
        $("#filter .view-all").removeClass("active");
        $(this).addClass("active");
    });

    // hide language switch if only 1 language available
    var matched = $(".wpml-ls ul li");

    if (matched.length == 1) {
        $(".wpml-ls").addClass("one-lang");
    }



    $(".page-template-sponsoring .section-eight .button").on("click", function (e) {
        $(".video-popup").addClass('active');
    });


    if ($("#countdown").length) {
        // Get the target date from data attribute
        var dateString = $('#countdown').data('acf-date');
        var dateParts = dateString.split(/[\/\s,:]+/);
        var targetDate = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0], dateParts[3], dateParts[4]).getTime();

        // Update the countdown every second
        var x = setInterval(function() {
            var now = new Date().getTime();
            var distance = targetDate - now;

            // Check if the target date is in the future
            if (distance > 0) {
                // Calculations for days, hours, minutes, and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the countdown
                $('#days').text(days);
                $('#hours').text(hours);
                $('#minutes').text(minutes);
                $('#seconds').text(seconds);
            } else {
                clearInterval(x);
                $('#countdown').html("<p>The countdown is over!</p>");
            }
        }, 1000);
    }



        function hideFacultatifElements() {
            $("*:not(body):not(html)").each(function() {
                var $this = $(this);
                if ($this.children().length === 0 && $this.text().trim() === "Facultatif") {
                    $this.hide();
                }
            });
        }
    
        // Run on page load
        hideFacultatifElements();
    
        // Run after AJAX requests (for dynamically loaded content)
        $(document).ajaxComplete(function() {
            hideFacultatifElements();
        });
    
        // Run after mutations (for live changes in DOM)
        var observer = new MutationObserver(function() {
            hideFacultatifElements();
        });
    
        observer.observe(document.body, { childList: true, subtree: true });



    
})(jQuery);
